module.exports = __webpack_public_path__ + "img/geren.64f4b856.png";